import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// this imports the version number from package.json, so we can show the version number in the ui with $state.store.app_version; also need something in vue.config.js (PACKAGE_VERSION)
		// run the following to update the third number; use 'minor' to update the second number and 'major' to update the first number
		// npm --no-git-tag-version version patch; npm run build; npm run serve
		app_version: process.env.PACKAGE_VERSION || '0.0.0',

		subdomain: window.satchel_subdomain,

		embedded_mode: false,
		embedded_mode_chooser: false,
		embedded_mode_chooser_outcomes_only: false,
		allow_framework_switching: true,	// this allows us to hide the framework switcher in embedded mode

		cureum_standards_tabbed: false,
		asset_counts: {},	// this will hold asset counts for cfitems in frameworks we load in cureum (or potentially in some other app)

		start_string: '',
		start_identifier: '',
		start_string_identifiers: '',

		// default values for site_config; some of these will be replaced by values coming in via site_config.php
		site_config: {
			// this can be used for special instances (e.g. rosetta_exchange, rosetta_align, satchel_commons) to trigger certain functionality
			instance_code: '',

			// properties marked with ** are required to be initially set in order for other things to work properly before we load the server-provided data from site_config.php
			// used in plugins/vuetify
			primary_color: '#1A237E',

			// included in index.html as the browser window/tab title
			index_title: 'Standards Satchel',

			// banner color and color of the "agency" string
			banner_color: '#1A237E',
			agency_color: '#EA80FC',
			app_color: '#82B1FF',

			// global font
			sans_serif_font: 'Roboto,Calibri,Helvetica Neue,Helvetica,Arial,sans-serif',

			// we have three different "app" identifiers here, for use in different contexts. If app_name only is specified, it will be used in all three
			// app_name is the "official" name of the application
			app_name: 'Standards Satchel',		// **
			// app_product_name is what we refer to the app as in the help documentation; if not specified, we will use app_name (see HelpMixin.js)
			app_product_name: 'Standards Satchel', // ** 
			// app_name_for_banner is the text to show to the right of the logo in the banner; if not specified, we use app_name (and it can be hidden altogether by show_app_name_with logo)
			// note that this should be commented out here in store, so that the default of using the app_name is honored
			// app_name_for_banner: 'Standards Satchel',
			// agency_name is shown in the little "tab" that hangs below the banner on when viewing the framework list; agency_name_css can alter the css of this tab, and agency_url is the link target if someone clicks on the tab; agency_name_for_banner can be used to override what's shown in the little tab, and can include html
			agency_name: 'Common Good Learning Tools',	// ** 
			agency_name_for_banner: '',
			agency_name_css: '',
			agency_url: 'https://commongoodlt.com/satchel',

			// for free patches of Satchel Commons, this will be 'yes' (set in send_token_signin_email when the patch is registered)
			free_patch: 'no',

			// for free patches, we leave agency_name and agency_url set to cglt and only set patch_name to the organization
			patch_name: '',

			// the "official" name of the Rosetta Align functionality
			rosetta_align_name: 'Satchel Rosetta Align',
			quick_align_resource_types: ['learning resource'],	// note that these should all be lower-case
			quick_align_auto_limit_branch_types: ['grade', 'grade_level', 'course'],	// note that these should all be lower-case

			// Note: it is acceptable to switch "app_name_for_banner" and "agency_name"; e.g. we might want to say "Carnegie Learning" in the main banner and "Standards Satchel" in the tab that hangs down

			// logo file; this file must be included in vue-cli/public/images
			agency_logo: 'cglt-globe-with-stars.svg',	// **
			show_app_name_with_logo: true,	// **

			// css to adjust the way the agency logo appears in the banner
			agency_img_outer_css: 'height:60px;margin-top:-5px;',
			agency_img_css: 'height:100%;',
			title_left_padding: '84px',

			// css to adjust the way the agency logo appears in the signin dialog
			agency_img_outer_css_signin: 'flex: 0 1 37%; text-align:right;',
			agency_img_css_signin: 'height:100px;',

			// html to show in the banner when the framework index page is showing (see AZ)
			// 'agency_img_index_page_html' => '<div style="position: absolute; z-index: 10000; left: 8px; top: 3px;"><img style="height: 82px;" src="/src/logos/az-paasport.png"/></div>'

			// links to be added to burger menu at top-right of app
			burger_links: [],	// **

			// other misc colors
			heading_color: '#000000',
			sub_heading_color: '#000000',
			dividing_line_color: '#999999',

			// title of the framework list index page
			framework_list_title: 'Framework Index',
			// title used for the browsing interface, e.g. "Standards Explorer"
			browsing_interface_title: 'Standards Explorer',
			// noun used for competencies (e.g. standard, item, or competency)
			comp_noun: 'standard',
			// noun used to refer to frameworks in, e.g., the help documentation
			framework_noun: 'standards framework',

			case_registry_name: 'Satchel Rosetta Exchange',
			case_registry_url: 'https://rosetta.commongoodlt.com',
			case_registry_registration_url: '',

			map_mode_enabled: 'false',
			map_square_data: '',	// if this isn't defined on the server, we will just show a line of tiles
			map_square_magic_numbers: [1000, 1000, 1000, 1000],

			// Value for disabling toggle ability between Table and Tile views; set in `FrameworkList.vue:24`
			view_toggle_enabled: 'true',

			tile_mode_enabled: 'true',
			site_headline: '',
			site_headline_css: '',
			site_headline_welcome: 'Welcome to Standards Satchel!',
			show_subject_coverage: 'false',
			show_cross_state_comparisons: 'false',
			site_headline_btns: [],

			// specify special descriptions to show for categories (implemented to allow for publishing a state's standards on behalf of a district)
			category_descriptions: [],

			resource_alignment_enabled: 'no',

			copyright_org: {},	// ['name'=>'1EdTech', 'url'=>'https://www.1edtech.org'],
			terms_of_use_url: '',	// 'https://www.imsglobal.org/casenetwork/terms',

			// "default" language used in the site; usually 'en', but, e.g., 'ko' for kr.commongoodlt.com ('kr' is the south korea domain extension; 'ko' is the language abbreviation)
			default_language: 'en',

			// trusted origins that are allowed to include this instance of satchel in applications
			post_message_trusted_origins: ['https://sparkl-ed.com'],

			// settings for the help system
			help_framework_satchel_origin: 'https://hd.satchelcommons.com',	// must not include a closing /
			help_framework_identifier: '7bee7ab2-97fb-4e4d-9250-83b6c44f9419',
			help_flavor: 'default',
			
			// settings for the crosswalk editor
			enable_crosswalk_editor_access: 'false',

			// whether or not to allow users to request emails with notifications for changed frameworks -- currently only available for rosetta exchange
			enable_framework_notifications: 'false',

			show_create_account_on_login: 'no',
			use_sanitized_options: 'false',
			bp_summary_policy: 'default',	// see below; other values are 'always' or 'never'; 
			bp_full_report_policy: 'default',	// see below; other values are 'always' or 'never'; 
			// old site_config value was show_bp_reports: 'false',

			// if this is 'false', mirrored frameworks won't be opened in this instance; instead we'll show the API url
			open_mirrors_in_satchel: 'true',
			case_portal_url: 'https://rosetta.commongoodlt.com',
			case_portal_name: 'Satchel Rosetta',

			framework_update_report_available: true,

			allow_in_framework_aliases: false,

			linked_cureum_instance: '',		// e.g. 'https://alabamalearningexchange.org'
		},

		app_initialized: false,
		mathjax_initialized: false,
		mathfield_uuid: '',
		redirected_from_cn2: false,		// for the transition from case network 2 to rosetta exchange
		login_error: '',
		user_info: {},
		frameworks_accessed: {},
		froala_key: '',
		enable_ap_export: false,
		framework_domain: 'https://agency.org',
		framework_access_report_fields: ['remote_addr'],
		start_string_regexps: [],
		session_renew_dialog_showing: false,
		today: '',
		
		// when a framework in wiki mode is opened in embed mode, wiki_flavor can be set to customize variable subs
		wiki_flavor: '',

		// cureum can set this to true via postmessage
		show_asset_counts_in_item_tiles: false,

		framework_records: [],
		mirrors: [],
		mirror_logs: {},
		case_tree_viewer_width: null,
		case_tree_viewer_height: null,
		case_tree_suppress_watcher: false,	// see CASEItem
		editing_enabled: {},
		suppress_hrc_reminder: false,
		framework_lastChangeDateTime: null,
		last_edited_item_field: 'fs_input',
		viewer_post_load_execute_fn: null,
		assoc_item_framework_identifiers: {},	// see case_utilities.get_lsdoc_identifier_locally_from_item_identifier and CASEFVAssociationsMixin.update_frameworks_with_associations

		framework_categories: [],

		resource_sets: [],

		comments: [],
		comment_groups: [],
		comments_previous_update_timestamp: {},
		comments_selected_group: -1,
		comments_selected_user: -1,
		comments_selected_suggested_edits: 'all',
		comments_show_resolved: true,
		comments_update_interval: 15000,

		// this holds data about archives of frameworks, indexed by lsdoc_identifier; used in update reports and the side-by-side editor
		framework_archives: {},

		// this holds entity archive data (see CASEEntityHistory) so we don't have to re-fetch it if the interface is opened and closed
		entity_archives: {},

		framework_access_selected_interval: 1,

		// difference between GMT and the timezone of the server that's saving MySQL dates, e.g. 300 if the server is on east coast time
		// PW 7/20/2022: actuallly if this isn't 0 it seems to screw things up...
		convert_to_local_date_offset_adjustment: 0,

		case_version_displayed: 'vext',	// could be set to v1p0 or v1p1

		// TODO: make the following 3 configurable
		standard_item_types: [
			{ value:"", text:"—" },
			{ value:"Grade", text:"Grade" },
			{ value:"Cluster", text:"Cluster" },
			{ value:"Pathway", text:"Pathway" },
			{ value:"Course", text:"Course" },
			{ value:"Domain", text:"Domain" },
			{ value:"Strand", text:"Strand" },
			{ value:"Competency", text:"Competency" },
			{ value:"Standard", text:"Standard" },
			{ value:"Element", text:"Element" },
			{ value:"Expectation", text:"Expectation" },
			{ value:"Component", text:"Component" },
			{ value:"Metadata Category", text:"Metadata Category" },
			{ value:"Competency Grouping", text:"Competency Grouping" },
		],
		languages: [
			{ value:"", text:"—" },
			{ value:'ar', text: 'Arabic' },
			{ value:'zh-CN', text: 'Chinese (Simplified)' },
			{ value:'zh-TW', text: 'Chinese (Traditional)' },
			{ value:'da', text: 'Danish' },
			{ value:'nl', text: 'Dutch' },
			{ value:'en', text: 'English' },
			{ value:'fil', text: 'Filipino' },
			{ value:'fi', text: 'Finnish' },
			{ value:'fr', text: 'French' },
			{ value:'de', text: 'German' },
			{ value:'iw', text: 'Hebrew' },
			{ value:'hi', text: 'Hindi' },
			{ value:'id', text: 'Indonesian' },
			{ value:'it', text: 'Italian' },
			{ value:'ja', text: 'Japanese' },
			{ value:'ko', text: 'Korean' },
			{ value:'ms', text: 'Malay' },
			{ value:'mi', text: 'Maori' },
			{ value:'no', text: 'Norwegian' },
			{ value:'pt', text: 'Portuguese' },
			{ value:'ru', text: 'Russian' },
			{ value:'es', text: 'Spanish' },
			{ value:'sw', text: 'Swahili' },
			{ value:'sv', text: 'Swedish' },
			{ value:'th', text: 'Thai' },
			{ value:'tr', text: 'Turkish' },
			{ value:'uk', text: 'Ukranian' },
			{ value:'ur', text: 'Urdu' },
			{ value:'vi', text: 'Vietnamese' },
		],

		// Default grades - populated from official_grades.US on initialization
		grades: [
			{ index: 0, value: '', text: '—', abbreviation: '' },
			{ index: 1, value: 'PK', text: 'PK', abbreviation: 'PK' },
			{ index: 2, value: 'KG', text: 'KG', abbreviation: 'KG' },
			{ index: 3, value: '01', text: '01', abbreviation: '1' },
			{ index: 4, value: '02', text: '02', abbreviation: '2' },
			{ index: 5, value: '03', text: '03', abbreviation: '3' },
			{ index: 6, value: '04', text: '04', abbreviation: '4' },
			{ index: 7, value: '05', text: '05', abbreviation: '5' },
			{ index: 8, value: '06', text: '06', abbreviation: '6' },
			{ index: 9, value: '07', text: '07', abbreviation: '7' },
			{ index: 10, value: '08', text: '08', abbreviation: '8' },
			{ index: 11, value: '09', text: '09', abbreviation: '9' },
			{ index: 12, value: '10', text: '10', abbreviation: '10' },
			{ index: 13, value: '11', text: '11', abbreviation: '11' },
			{ index: 14, value: '12', text: '12', abbreviation: '12' },
			{ index: 15, value: 'College', text: 'College', abbreviation: 'C' }
		],
		// Official grade systems from backend config (CFG->official_grades)
		// Frameworks can also define custom grades in SSFrameworkData.education_levels
		official_grades: {
			US: [
				{ index: 0, value: '', text: '—', abbreviation: '' },
				{ index: 1, value: 'PK', text: 'PK', abbreviation: 'PK' },
				{ index: 2, value: 'KG', text: 'KG', abbreviation: 'KG' },
				{ index: 3, value: '01', text: '01', abbreviation: '1' },
				{ index: 4, value: '02', text: '02', abbreviation: '2' },
				{ index: 5, value: '03', text: '03', abbreviation: '3' },
				{ index: 6, value: '04', text: '04', abbreviation: '4' },
				{ index: 7, value: '05', text: '05', abbreviation: '5' },
				{ index: 8, value: '06', text: '06', abbreviation: '6' },
				{ index: 9, value: '07', text: '07', abbreviation: '7' },
				{ index: 10, value: '08', text: '08', abbreviation: '8' },
				{ index: 11, value: '09', text: '09', abbreviation: '9' },
				{ index: 12, value: '10', text: '10', abbreviation: '10' },
				{ index: 13, value: '11', text: '11', abbreviation: '11' },
				{ index: 14, value: '12', text: '12', abbreviation: '12' },
				{ index: 15, value: 'College', text: 'College', abbreviation: 'C' },
			],
		},
		// the values listed above are the official best practices for CASE, but some agencies don't follow these best practices...
		alt_grades: [
			{ index:2, value:"K", text:"K", abbreviation:"K" },
			{ index:3, value:"1", text:"1", abbreviation:"1" },
			{ index:4, value:"2", text:"2", abbreviation:"2" },
			{ index:5, value:"3", text:"3", abbreviation:"3" },
			{ index:6, value:"4", text:"4", abbreviation:"4" },
			{ index:7, value:"5", text:"5", abbreviation:"5" },
			{ index:8, value:"6", text:"6", abbreviation:"6" },
			{ index:9, value:"7", text:"7", abbreviation:"7" },
			{ index:10, value:"8", text:"8", abbreviation:"8" },
			{ index:11, value:"9", text:"9", abbreviation:"9" },
		],

		// note: ext:satchelAIOnly association type not explicitly listed here...
		
		association_type_labels: {
			exactMatchOf: 'Exact Match',				// “Equivalent to. Used to connect derived CFItem to CFItem in original source CFDocument.”
			replacedBy: 'Replaced By',					// “The origin of the association has been supplanted by, displaced by, or superseded by the destination of the association.”
			hasSkillLevel: 'Has Skill Level',			// “The destination of this association is understood to define a given skill level i.e. Reading Lexile 100, Depth Knowledge 2, or Cognitive Level (Blooms Taxonomy) etc.”
			isRelatedTo: 'Related',						// “The origin of the association is related to the destination in some way that is not better described by another association type.”
			isPartOf: 'Is Part Of',						// “The origin of the association is included either physically or logically in the item at the destination of the association. This classifies an item as being logically or semantically contained as a subset of the destination.”
			precedes: 'Precedes',						// “The origin of the association comes before the destination of the association in time or order.”
			exemplar: 'Is Exemplar Of',					// “The target/destination node is an example of best practice for the definition of the source/origin.”
			isPeerOf: 'Peer Of',						// “The source/origin is a peer of of the target/destination.”
			isTranslationOf: 'Is Translation Of',		// “”
			isChildOf: 'Is Child Of',					// “To represent the structural relationship in a taxonomy between parent and child. The source/origin is a child of the target/destination.”

			// extensions created by Satchel crosswalk tool
			'ext:isNearExactMatch': 'Near-Exact Match',
			'ext:isCloselyRelatedTo': 'Closely Related',
			'ext:isModeratelyRelatedTo': 'Moderately Related',
			'ext:hasNoMatch': 'Has No Match',

			// extended in Satchel
			copiedFromSource: 'Copied From',
			aliasOf: 'Has Internal Alias',				// within-framework alias -- can be created with care
			aliasOfExternal: 'External Alias Of',		// between-framework alias -- allowed as of 8/2024
			'ext:hasRubric': 'Has Rubric',
			'ext:hasRubricCriterion': 'Has Rubric Criterion',
			'ext:hasRubricCriterionLevel': 'Has Rubric Criterion Level',
			'ext:hasSubstitute': 'Has Substitute',		// added by request of GaDOE 2/18/2025

			'ext:isAlignedTo': 'Is Aligned To',		// for resource collection frameworks

			'ext:linkedTo': 'Linked To',
		},
		association_type_labels_reverse: {
			exactMatchOf: 'Exact Match',
			replacedBy: 'Replaces',
			hasSkillLevel: 'Is Skill Level Of',
			isRelatedTo: 'Related',
			isPartOf: 'Has Part',
			precedes: 'Follows',
			exemplar: 'Has Exemplar',
			isPeerOf: 'Peer Of',
			isTranslationOf: 'Is Translation Of',
			isChildOf: 'Is Parent Of',

			// extensions created by Satchel crosswalk tool
			'ext:isNearExactMatch': 'Near-Exact Match',
			'ext:isCloselyRelatedTo': 'Closely Related',
			'ext:isModeratelyRelatedTo': 'Moderately Related',
			'ext:hasNoMatch': 'Has No Match',

			// extended in Satchel
			copiedFromSource: 'Copied To',

			// NOTE: I don't think we ever show the "reversed" alias associations
			aliasOf: 'Has Int. Alias',
			aliasOfExternal: 'Has Ext. Alias',

			'ext:hasRubric': 'Is Rubric For',
			'ext:hasRubricCriterion': 'Is Rubric Criterion For',
			'ext:hasRubricCriterionLevel': 'Is Rubric Criterion Level For',
			'ext:hasSubstitute': 'Is Substitute For',		// added by request of GaDOE 2/18/2025

			'ext:isAlignedTo': 'Has Alignment',		// for resource collection frameworks

			'ext:linkedTo': 'Linked From',
		},
		association_type_icons: {
			exactMatchOf: 'fas fa-bullseye',
			replacedBy: 'fas fa-left-right',
			hasSkillLevel: 'fas fa-left-right',
			isRelatedTo: 'fas fa-left-right',
			isPartOf: ['fas fa-arrow-right-to-bracket', 'fas fa-arrow-right-from-bracket'],
			precedes: ['fas fa-play-down', 'fas fa-play-up'],
			exemplar: 'fas fa-left-right',
			isPeerOf: 'fas fa-left-right',
			isTranslationOf: 'fas fa-language',
			isChildOf: ['fas fa-circle-right', 'fas fa-circle-left'],

			// extensions created by Satchel crosswalk tool
			'ext:isNearExactMatch': 'fas fa-circle-dot',
			'ext:isCloselyRelatedTo': 'fas fa-circle',
			'ext:isModeratelyRelatedTo': 'fas fa-circle-half-stroke',
			'ext:hasNoMatch': 'fas fa-ban',

			// extended in Satchel
			copiedFromSource: ['fas fa-copy-reverse', 'fas fa-copy'],
			aliasOf: 'fas fa-clone',
			aliasOfExternal: 'fas fa-clone',
			'ext:hasRubric': 'fas fa-ballot-check',
			'ext:hasRubricCriterion': 'fas fa-ballot-check',
			'ext:hasRubricCriterionLevel': 'fas fa-ballot-check',
			'ext:hasSubstitute': 'fas fa-right-left',

			'ext:isAlignedTo': 'fas fa-map',

			'ext:linkedTo': ['fas fa-arrow-right', 'fas fa-arrow-left'],
		},
		// this is the order we want association types to appear in
		association_type_order: [
			'ext:linkedTo',
			'exactMatchOf',
			'ext:isNearExactMatch',
			'ext:isCloselyRelatedTo',
			'ext:isModeratelyRelatedTo',
			'isRelatedTo',
			'ext:hasNoMatch',
			'precedes',
			'ext:hasSubstitute',
			'replacedBy',
			'hasSkillLevel',
			'isPartOf',
			'isPeerOf',
			'exemplar',
			'isTranslationOf',
			'ext:hasRubric',
			'ext:hasRubricCriterion',
			'ext:hasRubricCriterionLevel',
			'isChildOf',
			'copiedFromSource',
			'aliasOf',
			'aliasOfExternal',
		],
		custom_association_types: [],

		// for ItemCopyInterface: remember these as long as the user doesn't reload the browser
		item_copy_duplicate_children: true,
		item_copy_use_sourceItemIdentifier: true,
		item_copy_make_aliases: true,
		item_copy_add_associations: false,
		item_copy_association_type: 'exactMatchOf',

		// for item import interface
		import_interface_show_advanced_options: false,
		import_interface_convert_newlines_to_spaces: true,

		// for update reports and archives
		update_records_timestamp: 0,
		update_records: null,
		update_record_ref_dates: null,
		archive_comps_timestamp: {},
		archive_comps: {},	// this is used for the update report
		archive_json: {},	// this is use for tracking changes
		last_managed_archive: null,
		last_framework_update_report: null,
		last_viewed_item_from_archive_comparison: null,
		change_type_filters_showing: {},

		usage_data: null,

		PDF_import_interface_last_pdf_data: null, // last pdf opened in the pdf import interface

		ai_import_files: [],
		ai_force_reprocess_files: true,

		crosswalk_selected_left_item: {},
		crosswalk_selected_right_item: {},
		crosswalk_available_left_items: {},
		crosswalk_available_right_items: {},
		crosswalk_revealed_left_item: {},
		crosswalk_revealed_right_item: {},
		crosswalk_chosen_left_item: {},
		crosswalk_chosen_right_item: {},
		last_crosswalk_opened: '',

		quick_align_run_stats: [],

		// for alignment tools
		base_item_for_alignment: {},
		calculated_ai_simscores: {},

		// framework_type_profiles will eventually be a defined CASE data structure; currently used in CASEItemAssociations
		framework_type_profiles: {},

		// if a user tries to create a framework with more than this number of items, we'll show a warning
		recommended_max_cfitems: 5000,

		// "local_storage settings": set defaults here; lst_initialize is called on initialization; call lst_set to set new values, possibly in computed:
		// foo: {
		// 	get() { return this.$store.state.lst.foo },
		// 	set(val) { this.$store.commit('lst_set', ['foo', val]) }
		// },
		// @update:foo="(val)=>foo=val"
		lst: {
			frameworks_or_resources_toggle: 'frameworks',	// set in App -- 'frameworks' (default) or 'resources'
			framework_list_view_mode: '',	// set in FrameworkList
			framework_list_header_dismissed: false,
			framework_list_show_mirrors_only: false,
			framework_list_show_sandboxes: true,
			framework_list_table_sort_by: 'lastChangeDateTime',
			framework_list_table_sort_desc: true,
			framework_list_show_crosswalks: false,
			bp_results_showing_in_framework_table: true,
			// framework_list_force_include_all_frameworks: false,				// PW 2/2026: remove this

			recent_frameworks: [],

			resource_set_item_assoc_weight_pct: 6,
			resource_set_list_items_per_page: 20,
			resource_set_list_table_sort_by: 'created_at',
			resource_set_list_table_sort_desc: true,
			resource_set_show_aligned_resources: true,
			resource_set_show_unaligned_resources: true,
			resource_set_show_no_match_resources: true,
			resource_set_show_resource_identifiers: false,
			resource_set_branches_to_align_hash: {},
			resource_set_batch_align_settings_showing_hash: {},
			resource_set_batch_min_alignments_hash: {},
			resource_set_batch_max_alignments_hash: {},
			resource_set_batch_simscore_threshold_hash: {},
			resource_set_table_sort_by: 'created_at',
			resource_set_table_sort_desc: false,
			resource_set_tba_framework_identifier_hash: {},
			resource_set_auto_starting_alignment: false,
			resource_set_item_alignments_wrap: true,
			resource_set_item_suggestions_wrap: true,
			resource_set_validation_chart_plot_type: 'mean_highest_rank_score',
			resource_set_validation_graph_order: 'resource',
			resource_normalize_match_score_bars: true,
			resource_children_or_alignable: 'children',
			resource_view_description_expanded: false,
			resource_view_full_content_expanded: false,

			align_leafs_only: true,
			align_current_resource_id: '',
			align_lowest_ancestor: '',
			align_comp_factors: '',
			align_limiters: {},
			align_base_framework_identifier: {},

			scram_show_simscores: false,
			scram_show_branch_columns: true,
			scram_show_citation_column: false,

			quick_align_payload: {},
			quick_align_advanced_options_showing: false,
			quick_align_use_resource_title: true,
			quick_align_use_resource_description: true,
			quick_align_use_resource_cross_alignment: true,

			archive_date_to_show: 'archive_framework_date',	// date_archived or archive_framework_date
			archive_col_option_details: false,
			archive_col_option_auto_archives: false,
			archive_update_summary_field: 'update_report_summary',
			update_report_type: 'update_type',
			update_report_by_update_type_sort: 'lastChangeDateTime',
			update_report_by_update_update_types: {
				item_updates_code_or_statement: true,
				item_updates_not_code_or_statement: true,
				item_updates_moved: true,
				items_created: false,
				items_deleted: false,
				assocs_updated: false,
				assocs_created: false,
				assocs_deleted: false,
				document_updated: false,
				dates_only: false,
			},
			update_report_by_framework_identifier: '',
			update_report_archive_compare_arr: null,
			show_identifiers_in_framework_table: false,
			gt_enabled: false,
			single_color_scheme_on: false,
			assoc_framework_menu_items4: {},
			assoc_type_menu_options2: {},
			import_parse_algo: 'algo1',
			import_pre_script: '',
			import_post_script: '',
			import_delimiter: 'tabs',
			make_association_association_type: 'isRelatedTo',
			make_association_save_to_crosswalk_framework_inter: true,
			make_association_save_to_crosswalk_framework_intra: false,
			make_association_all_types_shown: false,
			make_association_right_framework_identifier: '',
			make_association_lowest_ancestor: '',
			make_association_keywords: '',
			font_size: 0,
			font_size_xs: -2,
			font_size_sm: -1,
			exemplar_collapsed: false,
			show_identifiers_in_tiles: false,
			show_color_coded_item_types: true,
			show_comments: false,
			show_associations: true,
			wrap_item_text: true,
			import_metadata_field: '',
			import_metadata_replace_or_append: 'replace',

			quick_align_framework_limit_to_branches: {},

			default_comment_group_id: {},
			comments_table_items_per_page: 50,
			comments_sort_order: 'date',	// 'date' or 'item'
			public_review_name: '',
			public_review_comments: [],

			associations_table_items_per_page: 50,
			items_table_items_per_page: 50,
			search_grade_low: '',
			search_grade_high: '',
			search_item_types: '',
			search_field_types: '',
			search_item_for_limit: '',
			search_limit_to_item: '',
			pinned_items: '',
			framework_access_report_count_type: 'webapp',
			usage_graph_dataset: 'smoothed',
			print_view_settings: '',
			viewer_mode: 'tree',	// tree, tiles, table
			viewer_table_mode: 'items',	// items, associations

			// see CrosswalkEditor
			crosswalk_interface_showing: 'summary',
			crosswalk_show_alignable_only: {},
			crosswalk_show_already_aligned: {},
			crosswalk_show_not_suggestible: {},
			crosswalk_match_levels: {},
			crosswalk_enable_diff_coloring: {},
			crosswalk_always_show_diff_coloring: {},
			crosswalk_table_spacing: {},
			crosswalk_items_per_page: {},
			crosswalk_make_alignments_for_types: {},
			crosswalk_include_branches_0: {},
			crosswalk_include_branches_1: {},
			crosswalk_exclude_branches_0: {},
			crosswalk_exclude_branches_1: {},

			canvas_branches_to_import: {},
			canvas_export_item_types: {},
			canvas_export_settings: {},

			powerschool_branches_to_import: {},
			powerschool_export_item_types: {},
			powerschool_export_settings: {},

			use_html_for_supplementalNotes: true,

			track_changes_fn: '',
			track_changes_fields: {
				fullStatement: true,
				humanCodingScheme: false,
				notes: false,
				supplementalNotes: false,
				CFItemType: false,
				educationLevel: false,
				highlight_text_diffs: true,
				// if loose_comparisons is true, we *don't* count changes to punctuation, spacing, or formatting as representing a change
				loose_comparisons: false,
			},
			side_by_side_editor_head_identifier: {},
			side_by_side_show_unchanged_items: true,
			
			association_suggestion_criteria: {
				fullStatement: true,
				humanCodingScheme: true,
				educationLevel: true,
				itemType: true,
				search: false,
				parents: false,
				siblings: false,
				existing_assocs: false,
				advanced: false,
				auto_suggest: false,
			},
			highlight_progression_changes: true,

			embedded_framework_identifier: '',

			associations_table_fields_to_show: '',
			associations_table_show_is_child_of: {},
			associations_table_show_framework_framework: {},
			show_unknown_framework_assocs: '',
			items_table_types_to_show: '',
			items_table_fields_to_show: '',

			froala_image_size: '500',
			froala_paste_mode: 'normal',

			mathlive_advanced_options: false,
			mathlive_chosen_keyboard_index: 1,

			PDF_import_interface_rule_sets: {},
			PDF_import_interface_misc: {
				last_pdf_opened: "",
			},
			PDF_import_interface_pdf_data: {},
			last_custom_script_run: '',
			last_custom_script_input: '',

			ai_import_model: '',
			ai_import_system_prompt: '',
			ai_import_satchelscript_protocol: '',
			ai_import_extraction_logic: '',
			ai_import_schema: '',
			ai_import_prompt: '',
			ai_import_last_response: '',
			ai_import_last_usage_metadata: {},
			ai_import_satchel_script: '',

			resource_ai_import_downscale_pdfs_before_run: false,
			resource_ai_import_textbook_title: '',

			resource_ai_import_textbook_title: '',

			resource_ai_import_item_type: 'Section',

			subject_comps_chosen_subject: 'english',
		},
		lst_prefix: 'sparklsalt_local_storage_setting_',
	},
	getters: {
		signed_in:(state) => { return state.user_info.first_name != '' },
		comments_hash:(state) => {
			// hash of comments referenced by item_identifier; makes looking things up by item easier
			let hash = {}
			for (let i = 0; i < state.comments.length; ++i) {
				let c = state.comments[i]
				if (!hash[c.framework_identifier]) hash[c.framework_identifier] = {}
				if (!hash[c.framework_identifier][c.item_identifier]) hash[c.framework_identifier][c.item_identifier] = []
				hash[c.framework_identifier][c.item_identifier].push(c)
			}

			// add public_review_comments (but don't double-add)
			// console.log('comments_hash', state.lst.public_review_comments.length)
			for (let i = 0; i < state.lst.public_review_comments.length; ++i) {
				let c = state.lst.public_review_comments[i]
				if (!hash[c.framework_identifier]) hash[c.framework_identifier] = {}
				if (!hash[c.framework_identifier][c.item_identifier]) hash[c.framework_identifier][c.item_identifier] = []
				if (!hash[c.framework_identifier][c.item_identifier].find(x=>x.comment_id == c.comment_id)) {
					hash[c.framework_identifier][c.item_identifier].push(new Comment(c))
				}
			}

			return hash
		},
		show_identifiers_in_tiles:(state) => { 
			// if we're in embedded_mode mode, never show identifiers in tiles
			if (state.embedded_mode) return false
			return state.lst.show_identifiers_in_tiles 
		},
		filtered_framework_records:(state) => {
			// this returns a list of framework records filtered by various things that we usually want to filter on

			// extract included_categories from site_config; if non-null, limit to these categories
			let included_categories = state.site_config.included_categories
			if (included_categories) included_categories = included_categories.split(/\s*,\s*/)

			// if we have included_subjects, limit by that too
			let included_subjects = state.site_config.included_subjects
			if (included_subjects) included_subjects = included_subjects.split(/\s*,\s*/)	
			// note that these should be `subject_guess_string` values, e.g. 'Math,English,Science,Social Studies',	

			// backdoor: if user has system admin rights, they can click a checkbox to see all categories and subjects
			// PW 2/2026: remove this
			// if (state.lst.framework_list_force_include_all_frameworks && vapp.is_granted('super')) {
			// 	included_categories = null
			// 	included_subjects = null
			// }

			let arr = []
			for (let framework_record of state.framework_records) {
				let ls_doc = framework_record.json.CFDocument

				// filter on included_subjects if we have them
				if (included_subjects) {
					// get guess for first subject; if it isn't in included_subjects, continue
					let subject = U.framework_subject_guess(framework_record.json.CFDocument)['subject_guess_string']
					if (!included_subjects.includes(subject)) continue
				}

				// if user isn't authorized to view this framework, skip it
				if (!vapp.is_granted('view_framework', ls_doc.identifier)) continue

				// also for our purposes here, skip crosswalk frameworks (which only include associations)
				if (ls_doc.frameworkType == 'crosswalk') continue

				// try to get an entry for the framework_record's category
				let category = framework_record.ss_framework_data.category

				// if included_categories are specified and this doesn't match an included_category, don't show it
				if (included_categories) {
					// if the framework hasn't been assigned a category, don't include
					if (!category) continue
					let found = false
					for (let ic of included_categories) {
						// note that we look here for map_labels
						if (category.indexOf('[[' + ic + ']]') > -1) {
							found = true
							break
						}
					}
					if (!found) continue
				}

				arr.push(framework_record)
			}
			return arr
		},
		crosswalk_framework_hash:(state) => {
			let hash = {}
			for (let framework_record of state.framework_records) {
				let ls_doc = framework_record.json.CFDocument

				// if user isn't authorized to view this framework, skip it
				// ? for now always include them in the hash
				// if (!vapp.is_granted('view_framework', ls_doc.identifier)) continue

				if (ls_doc.frameworkType == 'crosswalk') {
					// the two frameworks that are crosswalked should be in the title
					// "Crosswalk: “Mathematics - Georgia Standards of Excellence” <-> “California Common Core State Standards - Mathematics” [23a8e45a-9d5a-11e7-81bc-064e21a83c7c <-> c6487102-d7cb-11e8-824f-0242ac160002]"
					let arr = ls_doc.title.match(/(“(.*?)” <-> “(.*?)” )?\[(.*?) <-> (.*?)\]/)
					if (!empty(arr)) {
						let o = {
							crosswalk_identifier: ls_doc.identifier,
							title1: arr[1] ?? 'Framework ' + arr[4],
							title2: arr[2] ?? 'Framework ' + arr[5],
							identifier1: arr[4],
							identifier2: arr[5],
						}
						if (!hash[o.identifier1]) hash[o.identifier1] = []
						if (!hash[o.identifier2]) hash[o.identifier2] = []
						hash[o.identifier1].push(o)
						hash[o.identifier2].push(o)
					} else {
						console.warn('couldn’t get crosswalked frameworks for crosswalk', extobj(framework_record))
					}
				}
			}
			return hash
		},
		open_mirrors_in_satchel:(state) => { return state.site_config.open_mirrors_in_satchel == 'true' },

		// current possible values (besides empty): 'rosetta_exchange', 'rosetta_align', 'satchel_commons'
		instance_code:(state) => { return state.site_config.instance_code },

		// if site_config.home_category is set, it means that we're on a shared-hosting instance (e.g. Satchel Commons and Rosetta Align), and we're viewing a subdomain
		viewing_subdomain:(state) => { 
			return !empty(state.site_config.home_category) 
		},
		home_category:(state) => { 
			return state.site_config.home_category 
		},
		user_can_create_new_for_subdomain:(state, getters) => {
			// if we're viewing a subdomain
			if (getters.viewing_subdomain) {
				// then the user can create new frameworks for the subdomain if user_info.allow_to_create_frameworks_for_category matches the home_category
				return state.user_info.allow_to_create_frameworks_for_category == getters.home_category
			}
			return false
		},

		frameworks_hidden:(state, getters) => {
			// if we're in a satchel_commons-type instance
			if (getters.instance_code == 'satchel_commons') {
				// and we're not viewing a subdomain
				if (!getters.viewing_subdomain) {
					// and the user isn't signed in with at least system editor access
					if (!(state.user_info.system_role == 'editor' || state.user_info.system_role == 'admin')) {
						// then all frameworks are hidden
						return true
					}
				}
			}
			return false
		},

		// if user_info.category_access is set, this designates which categories the user has access to
		category_access:(state) => { 
			// for 'ALL', the user has access to all categories
			if (state.user_info.category_access == 'ALL') {
				return 'all'

			// 'CORE4' and 'TRIAL' means the user has access to a certain number of frameworks; for now we're treating this on the client side the same as 'all',
			// and leaving it to CGLT partner support to keep track of who has accessed what
			} else if (state.user_info.category_access == 'CORE4' || state.user_info.category_access == 'TRIAL') {
				return 'all'

			// else this will usually be a single string (e.g. 'CA'), but allow for multiple
			} else if (!empty(state.user_info.category_access)) {
				return state.user_info.category_access.split(/\s*,\s*/)
			}

			// if we get to here, the user isn't explicitly authorized for any categories, so if the instance limits access (e.g. commons and rosetta), they can't download anything
			return null
		},

		// this determines if users can view the best practice review summaries from the framework list
		bp_review_summaries_available:(state, getters) => {
			// if site_config.bp_summary_policy == 'never', NEVER show
			if (state.site_config.bp_summary_policy == 'never') {
				return false

			// if site_config.bp_summary_policy == 'always', ALWAYS show
			} else if (state.site_config.bp_summary_policy == 'always') {
				return true

				// else bp_summary_policy should be 'default', so...

				// if user has system reviewer rights or above, show
			} else if (['reviewer', 'editor', 'admin'].includes(state.user_info.system_role)) {
				return true

			// for rosetta exchange, ALWAYS show
			} else if (getters.instance_code == 'rosetta_exchange') {
				return true

			// for satchel commons...
			} else if (getters.instance_code == 'satchel_commons') {
				// if user is authorized to create frameworks for the patch, show
				if (getters.user_can_create_new_for_subdomain) {
					return true
				}
			}

			// if we get to here, don't show
			return false
		},
		
		// this determines if users can see the option to view full bp review reports
		// note, though, that vapp.signed_in_only may prevent actually viewing reports in some circumstances
		bp_review_full_reports_available:(state, getters) => {
			// if site_config.bp_full_report_policy == 'never', NEVER show
			if (state.site_config.bp_full_report_policy == 'never') {
				return false

			// if site_config.bp_full_report_policy == 'always', ALWAYS show
			} else if (state.site_config.bp_full_report_policy == 'always') {
				return true

				// else bp_full_report_policy should be 'default', so...

			// if user has system reviewer rights or above, show
			} else if (['reviewer', 'editor', 'admin'].includes(state.user_info.system_role)) {
				return true

			// for rosetta exchange, ALWAYS show the button
			} else if (getters.instance_code == 'rosetta_exchange') {
				return true

			// for satchel commons...
			} else if (getters.instance_code == 'satchel_commons') {
				// if user is authorized to create frameworks for the patch, show the btn
				if (getters.user_can_create_new_for_subdomain) {
					return true
				}
			}

			// if we get to here, default is to not show, but signed_in_only might allow it
			return false
		},

	},
	mutations: {
		set(state, payload) {
			// this.$store.commit('set', ['key', val])
			// update state property 'key' to value 'val'
			if (payload.length == 2) {
				state[payload[0]] = payload[1]
				return
			}

			var o = payload[0]
			var key = payload[1]
			var val = payload[2]

			// this.$store.commit('set', ['obj', 'key', val])
			// update property 'key' of 'o' to value 'val'
			if (typeof(o) == 'string') {
				if (state[o][key] == undefined) Vue.set(state[o], key, val)
				else state[o][key] = val
				return
			}

			// this.$store.commit('set', [obj, 'key', true])
			// this.$store.commit('set', [obj, ['level_1_key', 'level_2_key'], true])
			// this.$store.commit('set', [obj, 'PUSH', 1])	// push 1 onto obj, which must be an array in this case
			// update property of obj, **WHICH MUST BE PART OF STATE!**
			if (typeof(key) == 'string') {
				if (key == 'PUSH') {
					o.push(val)
				} else if (key == 'UNSHIFT') {
					o.unshift(val)
				} else if (key == 'SPLICE') {
					// in this case val will be the 'start' index for splice
					// if we got a fourth and fifth value in payload, payload[3] is the 'deleteCount' index for splice (i.e. 0, meaning that we're adding without deleting)
					if (!empty(payload[3]) && !empty(payload[4])) {
						o.splice(val, payload[3], payload[4])

					// else if we got a fourth value in payload (this is more common), replace the old value with the new value
					} else if (!empty(payload[3])) {
						o.splice(val, 1, payload[3])

					// otherwise just take the val-th item out
					} else {
						o.splice(val, 1)
					}
				} else if (val == '*DELETE_FROM_STORE*') {
					// delete the val if it existed (if it didn't exist, we don't have to do anything)
					if (o[key] != undefined) Vue.delete(o, key)
				} else if (o[key] == undefined) {
					Vue.set(o, key, val)
				} else {
					o[key] = val
				}
			} else {
				for (var i = 0; i < key.length-1; ++i) {
					o = o[key[i]]
					if (empty(o)) {
						console.log('ERROR IN STORE.SET', key, val)
						return
					}
				}
				if (o[key[i]] == undefined) Vue.set(o, key[i], val)
				else if (val == '*DELETE_FROM_STORE*') Vue.delete(o, key[i])
				else o[key[i]] = val
			}

			// samples:
			// this.$store.commit('set', [this.exercise, ['temp', 'editing'], true])
			// this.$store.commit('set', [this.qstatus, 'started', true])
		},

		push(state, payload) {
			// this.$store.commit('push', ['key', val])
			// push value 'val' onto property 'key', which must be an array
			if (payload.length == 2 && typeof(payload[0]) == 'string') {
				state[payload[0]].push(payload[1])
				return
			}

			// this.$store.commit('push', [obj, val])
			// push value onto array property of obj, **WHICH MUST BE PART OF STATE!**
			var o = payload[0]
			var val = payload[1]
			o.push(val)
		},

		add_to_array(state, payload) {
			// add to the array, checking first to make sure it's not already there
			// this.$store.commit('add_to_array', [array, old_val])
			let arr = payload[0]
			let val = payload[1]

			// if it doesn't already exist, add to the array
			if (arr.findIndex(x=>x==val) == -1) {
				arr.push(val)
			}
		},

		replace_in_array(state, payload) {
			// this.$store.commit('replace_in_array', [array, old_val, new_val])
			let arr = payload[0]

			// try to find the index of the old_val; caller can send either a value to look for directly, or a property and a value
			let i, new_val
			if (payload.length == 3) {
				let old_val = payload[1]
				new_val = payload[2]
				i = arr.findIndex(x=>x==old_val)
			} else {
				let prop = payload[1]
				let old_val = payload[2]
				new_val = payload[3]
				i = arr.findIndex(x=>x[prop]==old_val)
			}

			if (i > -1) {
				// if found, replace with new_val; have to use splice for reactive arrays (see vue documentation)
				arr.splice(i, 1, new_val)
			} else {
				// else push
				arr.push(new_val)
			}
		},

		splice_from_array(state, payload) {
			// this.$store.commit('splice_from_array', [array, old_val])
			let arr = payload[0]
			let old_val = payload[1]

			// try to find the index of the old_val
			let i = arr.findIndex(x=>x==old_val)
			if (i > -1) {
				// if found, remove from array
				arr.splice(i, 1)
			}
		},

		splice_from_array_by_index(state, payload) {
			// this.$store.commit('splice_from_array', [array, old_val])
			let arr = payload[0]
			let i = payload[1]

			arr.splice(i, 1)
		},

		// fns to initialize and set local_storage settings
		lst_initialize(state) {
			for (let key in state.lst) {
				let val = U.local_storage_get(state.lst_prefix + key)
				if (!empty(val)) {
					state.lst[key] = val
				}
			}
		},

		// this.$store.commit('lst_set', ['mc_mode', 'bubbles'])
		lst_set(state, payload) {
			let key, val
			if (typeof(payload) == 'string') {
				// if a single string value is sent in, we just save in local_storage; presumably the changed value will have been already saved via set
				U.local_storage_set(state.lst_prefix + payload, state.lst[payload])
			}

			if (Array.isArray(payload)) {
				key = payload[0]
				val = payload[1]
			} else {
				key = payload.key
				val = payload.val
			}

			// save in state
			state.lst[key] = val

			// now save in local_storage
			U.local_storage_set(state.lst_prefix + key, val)
		},

		// use this for hashes where we need different values for different contexts (e.g. different frameworks in Satchel)
		// get() { return this.$store.state.lst.foo[this.lst_key] ?? true },	// this.lst_key should be the value we're hashing on
		// set(val) { this.$store.commit('lst_set_hash', ['foo', this.lst_key, val]) }
		lst_set_hash(state, payload) {
			let key = payload[0]
			let key_key = payload[1]
			let val = payload[2]

			// copy the hash, then set the val for key_key, then set state.lst
			let o = $.extend(true, {}, state.lst[key])
			o[key_key] = val
			state.lst[key] = o

			// now save in local_storage
			U.local_storage_set(state.lst_prefix + key, o)
		},

		lst_clear(state, key) {
			U.local_storage_clear(state.lst_prefix + key)
		},

		item_moved(state, payload) {
			// this is called by a computed property in CASETree and CASEItem when an item is drag-and-drop moved into place.
			// payload will include the framework_record we're updating, the parent_node...
			let [framework_record, parent_node, new_children_array] = payload
		},

		write_site_config(state) {
			// index.html includes site_config.php, which just writes this out for us; app.vue then calls commit.write_site_config so we have the config data right away (even before the initialize_app service runs)

			// just to be safe, if we don't yet have post_message_trusted_origins for some reason, call again in 100 ms (see also PostMessageMixin)
			if (empty(window.satchel_site_config)) {
				// but give up after 50 tries
				if (!vapp.write_site_config_try_count) vapp.write_site_config_try_count = 1
				if (vapp.write_site_config_try_count >= 50) return
				++vapp.write_site_config_try_count
				setTimeout(x=>{vapp.$store.commit('write_site_config')}, 100)
				console.log('retrying write_site_config in 100ms')
				return
			}

			// set incoming values property-by-property, so that we retain default values set above
			for (let key in window.satchel_site_config) {
				state.site_config[key] = window.satchel_site_config[key]
			}

			let style_rules = [
				sr(' .k-banner-color { background-color:$1!important; }', state.site_config.banner_color),
				sr(' .k-agency-color { color:$1!important; }', state.site_config.agency_color),
				sr(' .k-banner-color-text { color:$1!important; }', state.site_config.banner_color),
				sr(' .k-app-title-color { color:$1!important; }', state.site_config.app_color),
				sr(' .k-toolbar-agency-img-outer { $1 }', state.site_config.agency_img_outer_css),
				sr(' .k-toolbar-agency-img { $1 }', state.site_config.agency_img_css),
				sr(' .k-toolbar-app-title { padding-left:$1; }', state.site_config.title_left_padding),
				sr(' .k-agency-title-extra { $1 }', state.site_config.agency_name_css),
				sr(' .k-framework-list-headline { $1 }', state.site_config.site_headline_css),
				sr(' .k-login-logo-wrapper-ext { $1 }', state.site_config.logo_wrapper_css_signin),
				sr(' .k-login__logo-text-ext { $1 }', state.site_config.logo_text_wrapper_css_signin),
				sr(' .k-login__logo-img-wrapper { $1 }', state.site_config.agency_img_outer_css_signin),
				sr(' .k-login__logo-img { $1 }', state.site_config.agency_img_css_signin),
				sr(' .k-sans-serif-font, .v-application, .v-btn, .fr-box.fr-basic .fr-element, .fr-view, .fr-popup .fr-special-character { font-family:$1,"Noto Music"!important; }', state.site_config.sans_serif_font),
				sr(' .k-custom-heading-color { color: $1!important; }', state.site_config.heading_color),
				sr(' .k-custom-sub-heading-color { color: $1!important; }', state.site_config.sub_heading_color),
				sr(' .k-custom-border-color { border-color: $1!important; }', state.site_config.dividing_line_color),
			]

			$('head').append('<style type="text/css">' + style_rules.join('\n') + '</style>')

			document.title = state.site_config.index_title
		},
		set_editing_enabled(state, { frameworkId, value }) {
			Vue.set(state.editing_enabled, frameworkId, value)
		},
	},
	actions: {
		initialize_app({state, commit, dispatch, getters}, payload) {
			// initialize local_storage settings
			commit('lst_initialize')

			U.loading_start('', 'initialize_app')

			return new Promise((resolve, reject)=>{
				if (empty(payload)) payload = {}

				U.ajax('initialize_app', payload, result=>{
					console.log('initialized', result)

					// note that site_config comes in separately (as of 4/20/2024; see above)

					if (result.status != 'ok') {
						U.loading_stop('initialize_app')
						reject(result)
						return
					} else if (!empty(result.login_error)) {
						// if we got this login_error, inform the user, but let them interact without being logged in
						if (result.login_error == 'Remote session data not found.') {
							console.warn('Remote session data not found (cglt_sso).')
						} else {
							U.loading_stop('initialize_app')
							// the initialization was called from the sign-in screen, so set state.login_error and reject
							state.login_error = result.login_error
							reject()
							return
						}
					}

					state.login_error = ''

					// if we received user_info, the user is logged in.
					if (!empty(result.user_info)) {
						// set user_info in store
						commit('set', ['user_info', new User_Info(result.user_info)])

						// and set frameworks_accessed
						commit('set', ['frameworks_accessed', result.frameworks_accessed])

						// if we received satchel_session_id_for_cglt_sso, save this value in U.session_id; the central ajax fn in utilities.js will pass this in for subsequent ajax calls
						if (!empty(result.satchel_session_id_for_cglt_sso)) U.session_id = result.satchel_session_id_for_cglt_sso

					} else {
						commit('set', ['user_info', new User_Info({})])
					}

					// store CFG things
					state.use_oidc_login = result.use_oidc_login
					state.use_auth0_login = result.use_auth0_login
					state.use_msft_oidc_login = result.use_msft_oidc_login

					// allow site_config to overwrite any of the above; note that values in site_config should be string 'true' or 'false'
					if (!empty(state.site_config.use_oidc_login)) state.use_oidc_login = (state.site_config.use_oidc_login === 'true')
					if (!empty(state.site_config.use_auth0_login)) state.use_auth0_login = (state.site_config.use_auth0_login === 'true')
					if (!empty(state.site_config.use_msft_oidc_login)) state.use_msft_oidc_login = (state.site_config.use_msft_oidc_login === 'true')

					state.cgrt_ip = result.cgrt_ip
					state.froala_key = result.froala_key
					state.enable_ap_export = result.enable_ap_export
					state.framework_domain = result.framework_domain
					state.framework_access_report_fields = result.framework_access_report_fields
					state.start_string_regexps = result.start_string_regexps
					state.start_string_identifiers = result.start_string_identifiers	// this may or may not come in; it will have a value if we have a ?start=xxx param but no framework identifier
					state.all_course_metadata_framework_identifier = result.all_course_metadata

					// allow a subdomain's site_config to override some settings from the config file
					if (state.site_config.framework_domain) state.framework_domain = state.site_config.framework_domain

					window.create_CASE_Custom_Extension_Fields(result.custom_extensions)
					window.create_CASE_Custom_Association_Types(result.custom_association_types)

					// framework_type_profiles: eventually we will want this in case_data_structures...
					state.framework_type_profiles = result.framework_type_profiles

					// Load official grade systems from backend config
					// Only override defaults if the backend provides a non-empty object
					if (result.official_grades && typeof result.official_grades === 'object' && !Array.isArray(result.official_grades) && Object.keys(result.official_grades).length > 0) {
						state.official_grades = result.official_grades
						// Set default grades array to US if available
						if (result.official_grades.US) {
							state.grades = result.official_grades.US
						}
					}

					// set today, for dealing with statusStartDates/statusEndDates
					state.today = date.format(new Date(), 'YYYY-MM-DD')

					// load all docs
					dispatch('get_lsdoc_list')

					// TODO: once we've done a deploy to all Satchel instances after 2/18/2026, we should be able to execute the followin code so we no longer load frameworks if frameworks_hidden is true
					// but maybe we don't actually need to worry about this, and actually we need the categories (and therefore the list of frameworks) in the registration form...
					/*
					let load_doc_list = true
					// if frameworks are hidden (see getters.frameworks_hidden for conditions)
					if (false && getters.frameworks_hidden) {
						// don't load frameworks, but do a couple of things get_lsdoc_list does after loading frameworks
						load_doc_list = false
						state.app_initialized = true
						U.loading_stop('initialize_app')
					}
					// otherwise all frameworks will be loaded when user logs in regardless of permissions
					if (load_doc_list) dispatch('get_lsdoc_list')
					*/

					// resolve, sending back the token_result param so that vapp can doe something with it
					resolve(result.token_result)
				})
			})
		},

		// U.loading_start()
		// let payload = {
		// 	service_url: 'user/save_user_updates',
		// 	other_data: 'foo',
		// }
		// this.$store.dispatch('service', payload).then((result)=>{
		// 	U.loading_stop()
		// 	// deal with result
		//
		// }).catch((result)=>{
		// 	U.loading_stop()
		// 	this.$alert('<b class="red--text">An error occurred:</b> ' + result.error)
		// }).finally(()=>{})
		service({state, commit, dispatch}, payload) {
			let service_url
			if (typeof(payload) == "string") {
				service_url = payload
				payload = {}
			} else {
				service_url = payload.service_url
				delete payload.service_url
			}

			return new Promise((resolve, reject)=>{
				U.ajax(service_url, payload, result=>{
					if (result.status != 'ok') {
						console.log('Error in service ' + service_url, result)
						reject(result)
						return
					}

					resolve(result)
				})
			})
		},

		get_lsdoc_list({state, commit, dispatch}) {
			// note that the loader should already have been initiated by the initialize service
			return new Promise((resolve, reject)=>{
				let payload = {}
				// use this if we want to get the full bp_report_data for each framework; we will always get bp_score and bp_issue_count
				if (false) payload.get_bp_report_data = 'yes'
				U.ajax('get_framework_list', payload, result=>{
					if (result.status != 'ok') {
						U.loading_stop('initialize_app')
						vapp.ping()		// call ping to check if the session is expired
						vapp.$alert('An error occurred when attempting to retrieve the framework list.')
						reject()
						return
					}

					// construct list of framework_categories as we process the framework_records
					let fcats = []
					let new_framework_records = []
					for (let record of result.records) {
						// console.log(record.framework_identifier)
						let json = JSON.parse(record.json)
						let doc = new CFDocument(json.case_document_json)
						delete(json.case_document_json)
						let framework_record = U.create_framework_record(doc.identifier, {CFDocument: doc}, json, false)
						// if mirror, include framework.next_auto_update
						if (!empty(record.next_auto_update)) framework_record.ss_framework_data.next_auto_update = record.next_auto_update
						// include bp_report_data if there (could be null)
						if (!empty(record.bp_report_data)) {
							framework_record.bp_report_data = JSON.parse(record.bp_report_data)
						}

						new_framework_records.push(framework_record)

						if (framework_record.ss_framework_data.category && !fcats.find(x=>x == framework_record.ss_framework_data.category)) {
							fcats.push(framework_record.ss_framework_data.category)
						}
					}
					state.framework_records = new_framework_records

					fcats.sort(U.natural_sort)
					state.framework_categories = fcats

					// set app_initialized to true only after framework_records have been loaded
					state.app_initialized = true

					setTimeout(x=>{ U.loading_stop('initialize_app') }, 0)

					// initiate google translate, and stop the loader, after some time
					// setTimeout(x=>{ 
					// 	console.log('initializing google translate')
					// 	vapp.initialize_google_translate() 
					// }, 2500)

					resolve()
				})
			})
		},

		// given an item_identifier, return the lsdoc_identifier that houses the item
		get_lsdoc_identifier_from_item_identifier({state, commit, dispatch}, item_data) {
			return new Promise((resolve, reject)=>{
				// as of 4/2025, item_data can be either a string or an array
				// if an array, send item_identifiers, and JSON.stringify; else just send the string as item_identifier
				let payload
				if ($.isArray(item_data)) payload = {item_identifiers: JSON.stringify(item_data)}
				else payload = {item_identifier: item_data}

				U.ajax('get_lsdoc_identifier_from_item_identifier', payload, result=>{
					if (result.status != 'ok') {
						// we would get this back if we asked about a single item and didn't find it
						// note that assoc_item_framework_identifiers doesn't have to be reactive
						state.assoc_item_framework_identifiers[payload.item_identifier] = 'unknown'
						reject(result.status)
						return
					}
					// if we asked about a single item, store it in assoc_item_framework_identifiers
					if (payload.item_identifier) {
						state.assoc_item_framework_identifiers[item_data] = result.lsdoc_identifier

					// else store data about all the item_identifiers we asked about
					} else {
						// result.lsdoc_identifier will be a hash indexed by the item_identifier of the found framework_identifiers
						for (let item_identifier of item_data) {
							let fi = result.lsdoc_identifier[item_identifier] || 'unknown'
							state.assoc_item_framework_identifiers[item_identifier] = fi
						}
					}
					resolve(result.lsdoc_identifier)
				})
			})
		},

		get_lsdoc({state, commit, dispatch}, payload) {
			return new Promise((resolve, reject)=>{
				let lsdoc_identifier, archive_filename, exemplar_archive_fn
				let payload_to_send = {}
				// payload could just be a string, which represents the lsdoc_identifier
				if (typeof(payload) == 'string') {
					lsdoc_identifier = payload
					archive_filename = null
					exemplar_archive_fn = null
				} else {
					// or it could be an object that must specify the lsdoc_identifier and might specify additional info...
					lsdoc_identifier = payload.lsdoc_identifier

					// an archive_filename could be sent in...
					if (payload.archive_filename) archive_filename = payload.archive_filename
					if (payload.exemplar_archive_fn) exemplar_archive_fn = payload.exemplar_archive_fn

					// and/or a `record_access` value of true could be sent in,
					if (payload.record_access) {
						// in which case we send access_type, screen_size, user_id, and framework_identifier
						payload_to_send = {
							access_type: 'webapp',	// note that we're accessing the framework through the web application
							screen_size: (vapp.$vuetify.breakpoint.xs || vapp.$vuetify.breakpoint.sm) ? 'small' : 'normal',
							user_id: state.user_info.user_id,
							// have to collect the user's IP address via the client (see index.html)
							ip_address: window.client_ip_address,
							framework_identifier: lsdoc_identifier
						}
					}
				}

				// by default we load the current json; but if archive_filename is specified, load the archived json
				let filepath
				if (empty(archive_filename)) filepath = sr('frameworks/$1.json', lsdoc_identifier)
				else filepath = sr('framework_archives/$1', archive_filename)

				// if we have a framework record for this framework already, set framework_json_loading to true
				let fr = state.framework_records.find(x=>x.lsdoc_identifier==lsdoc_identifier)
				if (fr) commit('set', [fr, 'framework_json_loading', true])

				// TODO: get_json_file will throw an error if the json is malformed; need to test what happens if that happens.
				U.get_json_file(filepath, payload_to_send, (json, may_have_latex) =>{
					// the json param should hold the CASE JSON for the framework, already JSON.parse'd
					// if it's a string, or if the json doesn't have a CFDocument, something went wrong
					if (typeof(json) == 'string' || !json.CFDocument) {
						console.log('!!!Error in get_lsdoc', json)
						// set framework_json_loaded to true so we don't keep trying to load the framework
						let fr = state.framework_records.find(x=>x.lsdoc_identifier==lsdoc_identifier)
						if (fr) {
							commit('set', [fr, 'framework_json_loading', false])
							commit('set', [fr, 'framework_json_loaded', true])
						}
						reject(json)
						return
					}

					// if the CASE json may have latex, initialize the MathJax parser
					if (may_have_latex) U.mathjax.initialize()

					// if the requested framework is one that is loaded into Satchel, the framework_record should already exist when this is called,
					let fr = state.framework_records.find(x=>x.lsdoc_identifier==lsdoc_identifier)
					if (fr) {
						// so all we have to do is store the json and set framework_json_loaded to true, which framework_record_load_json does
						U.framework_record_load_json(fr, json)
					} else {
						// the requested framework wasn't one that we know about
						console.log('framework_record not found')
					}
					// note that we don't set framework_json_loading to false here; that is left for the caller to do, in case it needs to also process the cfo
					resolve()
				})
			})
		},

		// retrieves a framework's sparkl_bot_vectors. Note that even if we already have the vectors for a framework, we may call this to refresh them
		get_framework_sparkl_bot_vectors({state, commit, dispatch}, payload) {
			// if payload is a string, it's a framework_identifier
			if (typeof(payload) == 'string') payload = {framework_identifier: payload}

			let fr = state.framework_records.find(x=>x.lsdoc_identifier==payload.framework_identifier)
			if (!fr) return

			// set fr.sparkl_bot_vectors_loading to true so callers know not to call this twice
			fr.sparkl_bot_vectors_loading = true

			// PW: started working on this in get_framework_sparkl_bot_vectors on 11/16/2024, but didn't get to testing it...
			if (false) payload.sb_ancestor_item_type = 'Standard'

			// caller should show loader if they wish to do so
			// U.loading_start()
			return new Promise((resolve, reject)=>{
				U.ajax('get_framework_sparkl_bot_vectors', payload, result=>{
					// U.loading_stop()

					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						vapp.$alert('An error occurred when attempting to retrieve the framework’s search vectors.')
						reject()
						return
					}

					// add to framework_records
					fr.sparkl_bot_vectors = JSON.parse(result.vector_hash)
					fr.sparkl_bot_vectors_loading = false
					resolve()
				})
			})
		},

		load_framework_archive_list({state, commit, dispatch}, lsdoc_identifier) {
			return new Promise((resolve, reject)=>{
				let payload = {
					user_id: state.user_info.user_id,
					framework_identifier: lsdoc_identifier,
				}

				U.loading_start()
				U.ajax('get_archive_list', payload, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						console.log('Error in get_archive_list ajax call'); vapp.ping(); return
					}

					// result.framework_archives.sort((a,b)
					// records will come in sorted with oldest first

					// PW: for now let's not show the current checkout archive; I think it's confusing
					// TODO for MZ: but if there have been edits since the checkout archive was created, don't set it as open_edit_archive='yes', because that effectively has become a permanent archive now (it won't be deleted)
					let framework_archives = []
					let last_comparison_summary = null
					for (let a of result.framework_archives) {
						if (a.open_edit_archive != 'yes') {
							a.comparison_summary = last_comparison_summary
							last_comparison_summary = a.comparison_summary_to_last
							delete a.comparison_summary_to_last

							if (a.update_report_summary) a.update_report_summary = JSON.parse(a.update_report_summary)

							framework_archives.push(a)
						}
					}

					// add a row for the current state
					let framework_record = state.framework_records.find(x=>x.lsdoc_identifier == lsdoc_identifier)
					if (framework_record) {		// we should always find the framework record, but just in case...
						framework_archives.push({
							timestamp: date.format(new Date(), 'YYYY-MM-DD HH:mm:ss', true),
							item_count: !empty(framework_record.ss_framework_data.item_count) ? framework_record.ss_framework_data.item_count : framework_record.json.CFItems.length,
							association_count: !empty(framework_record.ss_framework_data.association_count) ? framework_record.ss_framework_data.association_count : framework_record.json.CFAssociations.length,
							assoc_count_not_child: !empty(framework_record.ss_framework_data.assoc_count_not_child) ? framework_record.ss_framework_data.assoc_count_not_child : framework_record.json.CFAssociations.length,
							archive_type: 'current',
							archive_lastChangeDateTime: framework_record.json.CFDocument.lastChangeDateTime,
							archive_fn: '',
							comparison_summary: last_comparison_summary,
						})
					}

					// set in framework_archives
					commit('set', [state.framework_archives, lsdoc_identifier, framework_archives])

					resolve()
					// format for each archive: { archive_fn, archive_lastChangeDateTime, archive_note, archive_type, assoc_count_not_child, item_count, association_count, comparison_summary, email, item_count, open_edit_archive, restored_from_timestamp, timestamp, update_report_summary }
				})
			})
		},

		reduce_case_json({state, commit, dispatch}, payload) {
			// this is just for debugging purposes
			// payload must include `json` and a list of `fns` to run:
			// vapp.$store.dispatch('reduce_case_json', {lsdoc_identifier: vapp.case_tree_component.framework_record.lsdoc_identifier, fns:['remove_empty_properties']})
			return new Promise((resolve, reject)=>{
				let fr = state.framework_records.find(x=>x.lsdoc_identifier == payload.lsdoc_identifier)
				if (empty(fr) || empty(fr.json)) {
					vapp.$alert('couldn’t find framework')
					return
				}

				U.reduce_case_json(vapp.$worker, fr.json, payload.fns).then((new_json)=>{
					console.log('done', new_json)
				})
			})
		},

		delete_lsdoc({state, commit, dispatch}, lsdoc_identifier) {
			let payload = {
				// user_id
				lsdoc_identifier: lsdoc_identifier
			}
			U.loading_start()
			return new Promise((resolve, reject)=>{
				U.ajax('delete_framework', payload, result=>{
					U.loading_stop()

					// if the action can't proceed because of an edit lock conflict, just show the error message then reload the window, which will cancel edit mode
					if (result.status == 'lock_conflict' || result.status == 'session_conflict') {
						vapp.$alert(result.message).then(x=>vapp.reload_window())
						reject()
						return
					}

					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						vapp.$alert('An error occurred when attempting to delete the framework.')
						reject()
						return
					}

					// remove from framework_records
					let index = state.framework_records.findIndex(x=>x.lsdoc_identifier==lsdoc_identifier)
					if (index > -1) {
						state.framework_records.splice(index, 1)
					}

					resolve()
				})
			})
		},

		archive_lsdoc({state, commit, dispatch}, payload) {
			// payload should include lsdoc_identifier and an optional `phrase` for the archive filename
			U.loading_start()
			return new Promise((resolve, reject)=>{
				U.ajax('archive_framework', payload, result=>{
					U.loading_stop()

					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						vapp.$alert('An error occurred when attempting to archive the framework.')
						reject()
						return
					}

					resolve(result.archive_time)
				})
			})
		},

		// user may initiate a sync check to mirror source, if mirror changes an archive is saved
		manual_mirror_update({state, commit, dispatch}, payload) {
			U.loading_start()
			return new Promise((resolve, reject)=>{
				// import_mirror_framework hands off to mirror_update, which also handles auto updates
				U.ajax('import_mirror_framework', payload, result=>{
					U.loading_stop()

					// if fail, still send result to caller so mirror info may be updated with fail data
					if (result.status !== 'ok') {
						console.log(sr('Error in mirror_update_by_user: $1', result.update_status))
						vapp.$alert("There was a problem checking this mirror's source for updates.")
					}
					resolve(result)
				})
			})
		},

		save_framework_data({state, commit, dispatch}, payload) {
			// payload.user_id = state.user_info.user_id
			let show_spinner = true
			if (payload.show_spinner === false) {
				show_spinner = false
				delete payload.show_spinner
			}

			// if update_item_types is true and payload includes any CFItems, deal with CFItemTypes
			// note: the caller can specifying to make *some* changes to CFItems, without sending all properties of the CFItems in.  we only want to run keep_item_types_in_sync in situations where the caller is actually specifying the CFItemType information about the to-be-updated items, because if we run keep_item_types_in_sync when the CFItemTypes are not specified, keep_item_types_in_sync will think all the CFItems are having their CFItemTypes deleted
			// note: by running this on payload, ItemEditor will update CFItem values properly upon service completion.
			let update_item_types = false
			if (payload.update_item_types && payload.CFItems && payload.CFItems.length > 0) {
				U.keep_item_types_in_sync(payload)
				update_item_types = true
				delete payload.update_item_types
			}

			let payload_to_send = $.extend(true, {}, payload)

			if (!empty(payload_to_send.CFItems)) payload_to_send.CFItems = U.encode_blocked_keywords(JSON.stringify(payload_to_send.CFItems))
			if (!empty(payload_to_send.CFAssociations)) payload_to_send.CFAssociations = U.encode_blocked_keywords(JSON.stringify(payload_to_send.CFAssociations))
			if (!empty(payload_to_send.CFDocument)) payload_to_send.CFDocument = U.encode_blocked_keywords(JSON.stringify(payload_to_send.CFDocument))
			if (!empty(payload_to_send.CFDefinitions)) payload_to_send.CFDefinitions = U.encode_blocked_keywords(JSON.stringify(payload_to_send.CFDefinitions))
			if (!empty(payload_to_send.CFRubrics)) payload_to_send.CFRubrics = U.encode_blocked_keywords(JSON.stringify(payload_to_send.CFRubrics))

			// we encode blocked keywords in the uploaded data to avoid firewall issues; set encode_blocked_keywords here to tell ajax to decode on the server
			payload_to_send.encode_blocked_keywords = ['CFItems', 'CFAssociations', 'CFDocument', 'CFDefinitions', 'CFRubrics']

			// send update_document_date=yes to always update the document date, unless update_document_date is explicitly passed in through payload
			if (empty(payload.update_document_date)) payload_to_send.update_document_date = 'yes'

			if (show_spinner) U.loading_start()
			return new Promise((resolve, reject)=>{
				U.ajax('save_framework_data', payload_to_send, result=>{
					if (show_spinner) U.loading_stop()

					// if the action can't proceed because of an edit lock conflict, just show the error message then reload the window, which will cancel edit mode
					if (result.status == 'lock_conflict' || result.status == 'session_conflict') {
						vapp.$alert(result.message).then(x=>vapp.reload_window())
						reject()
						return
					}

					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						vapp.$alert('An error occurred when attempting to save the standards data.')
						reject()
						return
					}

					// if update_document_date was 'yes', update the lastChangeDateTime value in the framework_record
					if (payload_to_send.update_document_date == 'yes') {
						let index = state.framework_records.findIndex(x=>x.lsdoc_identifier == payload.lsdoc_identifier)
						if (index > -1) {
							state.framework_records[index].json.CFDocument.lastChangeDateTime = result.document_lastChangeDateTime
						}
					}

					// if update_item_types is true and we sent CFItemType values, update them in the store here, so caller isn't responsible for these
					if (update_item_types && payload.CFDefinitions?.CFItemTypes) {
						let fr = state.framework_records.find(x=>x.lsdoc_identifier == payload.lsdoc_identifier)
						if (fr) {
							if (!fr.json.CFDefinitions) fr.json.CFDefinitions = {}
							if (payload.CFDefinitions.CFItemTypes == '*CLEAR*') {
								fr.json.CFDefinitions.CFItemTypes = []
							} else {
								// note that we always save CFItemTypes as a block, so we can always keep them in synch here as a block; we just have to update lastChangeDateTimes
								for (let cit of payload.CFDefinitions.CFItemTypes) {
									if (cit.lastChangeDateTime == '*NOW*') cit.lastChangeDateTime = result.document_lastChangeDateTime
								}
								fr.json.CFDefinitions.CFItemTypes = payload.CFDefinitions.CFItemTypes
							}
						}
					}

					// caller is responsible for updating other store values, and may need to access result.document_lastChangeDateTime in the process of making such updates, i.e:
					// this.CFDocument.lastChangeDateTime = result.document_lastChangeDateTime
					commit('set', ['framework_lastChangeDateTime', result.document_lastChangeDateTime])

					// do we need this anymore? let's not do it if we're not showing the spinner
					if (show_spinner) dispatch('reset_service')

					// show "saved" indicator
					if (show_spinner) vapp.show_saved_indicator()

					resolve(result)
				})
			})
		},

		save_framework_categories({state, commit, dispatch}, framework_updates) {
			// console.log(framework_updates)
			let payload = {
				framework_updates: framework_updates
			}
			return new Promise((resolve, reject)=>{
				U.loading_start()
				U.ajax('admin_save_framework_categories', payload, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						console.log('Error updating framework categories')
						reject()
						return
					}
					// we don't have to do anything on return
					resolve()
				})
			})
		},

		delete_framework_items({state, commit, dispatch}, payload) {
			return new Promise((resolve, reject)=>{
				U.loading_start()
				let {framework_record, nodes_to_delete} = payload
				let json = framework_record.json

				// delete from the framework file/DB
				let data = {
					lsdoc_identifier: framework_record.lsdoc_identifier,
					CFItems: [],
					CFAssociations: []
				}

				// recursively add CFItems
				let add_cfitem_to_delete = (node) => {
					// note that we always purge this node
					nodes_to_purge.push(node)

					// if this is the only instance of the item in the tree, wipe it out completely
					if (node.cfitem.tree_nodes.length == 1) {
						console.log('wiping out: ' + node.cfitem.fullStatement)
						data.CFItems.push({ identifier: node.cfitem.identifier, delete: 'yes' })
						U.delete_item_from_json(framework_record, node.cfitem.identifier)
						// add associations to this cfitem identifier so we delete those too
						for (let i = framework_record.json.CFAssociations.length-1; i >= 0; --i) {
							let cfa = framework_record.json.CFAssociations[i]
							// remove any association whose origin OR destination is this identifier
							if (cfa.originNodeURI.identifier == node.cfitem.identifier || cfa.destinationNodeURI.identifier == node.cfitem.identifier) {
								if (!data.CFAssociations.find(x=>x.identifier == cfa.identifier)) {
									data.CFAssociations.push({ identifier: cfa.identifier, delete: 'yes' })
									U.delete_association_from_json(framework_record, cfa.identifier)
								}
							}
						}

						// in this case we also recurse to delete the item's children
						for (let child_node of node.children) {
							add_cfitem_to_delete(child_node)
						}

					} else {
						console.log('removing assoc only for: ' + node.cfitem.fullStatement)
						// else we just remove the association placing the item in this position in the tree
						for (let i = framework_record.json.CFAssociations.length-1; i >= 0; --i) {
							let cfa = framework_record.json.CFAssociations[i]
							// this item (origin) ->isChildOf-> parent item (destination)
							if (cfa.associationType == 'isChildOf' && cfa.originNodeURI.identifier == node.cfitem.identifier && cfa.destinationNodeURI.identifier == node.parent_node.cfitem.identifier) {
								if (!data.CFAssociations.find(x=>x.identifier == cfa.identifier)) {
									data.CFAssociations.push({ identifier: cfa.identifier, delete: 'yes' })
									U.delete_association_from_json(framework_record, cfa.identifier)
								}
							}
						}

						// and in this case *don't* delete the item's children
					}
				}

				// add all nodes and their children to delete
				let nodes_to_purge = []
				for (let node of nodes_to_delete) {
					add_cfitem_to_delete(node)
				}

				// there may now be some items that are orphaned, so remove them too.
				// That is, any item that (doesn't have an association where it is an origin) -- i.e. (isn't a child of something) -- should be deleted
				//    also delete all associations where that item is the destination
				// keep doing this until we don't change anything; this removes orphan children, grandchildren, etc.
				// this assumes that the framework does not include *items* that aren't part of the tree structure
				// the framework *can* include *associations* referring to items that *were never* included in the tree structure
				// use U.reduce_case_json.remove_orphan_items for this, in part because it runs much faster in a worker
				U.reduce_case_json(vapp.$worker, framework_record.json, 'remove_orphan_items').then((data_from_remove_orphans)=>{
					console.log('remove_orphan_items', data_from_remove_orphans)

					// merge return value with data and delete items/associations from json
					for (let item of data_from_remove_orphans.CFItems) {
						console.log('adding item to delete: ' + item.identifier)
						data.CFItems.push(item)
						U.delete_item_from_json(framework_record, item.identifier)
					}
					for (let association of data_from_remove_orphans.CFAssociations) {
						data.CFAssociations.push(association)
						U.delete_association_from_json(framework_record, association.identifier)
					}

					// need to purge nodes and send deletions to server here, in the callback after the worker has run
					for (let i = nodes_to_purge.length-1; i >= 0; --i) {
						U.delete_node_from_cfo(framework_record.cfo, nodes_to_purge[i])
					}

					console.log('deleting...', data)

					data.update_item_types = true	// this will trigger the save_framework_data dispatch fn to deal with CFItemTypes

					// note that we have already purged the nodes and json, so we don't need to do anything about those when we get back from the service call
					dispatch('save_framework_data', data).then(()=>{
						U.loading_stop()

						// but we will re-run update_frameworks_with_associations, in case any assocs or copies need to be updated in the tree view associations display
						if (vapp.case_tree_component) vapp.case_tree_component.update_frameworks_with_associations()

						resolve()
					}).catch(e=>{
						// but if there was a problem, the user needs to reload
						U.loading_stop()
						vapp.$alert('A problem occurred when attempting to delete the items. You should reload your browser window now.').then(x=>vapp.reload_window())
					})

				}).catch(x=>{
					console.log('error in remove_orphan_items', x)
					U.loading_stop()
				})
			})
		},

		delete_associations({state, commit, dispatch}, payload) {
			// this is for deleting non-isChildOf associations
			return new Promise((resolve, reject)=>{
				let {framework_record, associations_to_delete, check_out_and_in, assoc_save_only, update_document_date} = payload

				let data = {
					lsdoc_identifier: framework_record.lsdoc_identifier,
					CFAssociations: []
				}
				if (check_out_and_in == 'yes') data.check_out_and_in = 'yes'
				if (!empty(assoc_save_only)) data.assoc_save_only = assoc_save_only
				if (!empty(update_document_date)) data.update_document_date = update_document_date

				for (let assoc of associations_to_delete) {
					data.CFAssociations.push({
						identifier: assoc.identifier,
						delete: 'yes',
					})
					// remove from associations_hash and from json
					U.remove_from_associations_hash(framework_record.cfo, assoc)
					U.delete_association_from_json(framework_record, assoc.identifier)

					// update associations showing in the tree, if showing
					if (vapp.case_tree_component) vapp.case_tree_component.update_association_display({assoc: assoc, actions: ['remove']})
				}

				console.log('deleting associations...', data)

				// note that we have already purged the json, so we don't need to do anything when we get back from the service call
				data.show_spinner = false
				dispatch('save_framework_data', data).then(()=>{
					resolve()
				}).catch(e=>{
					// but if there was a problem, the user needs to reload
					U.loading_stop()
					vapp.$alert('A problem occurred when attempting to delete the association. You should reload your browser window now.').then(x=>vapp.reload_window())
				})
			})
		},

		// Commenting functionality
		get_comments_for_framework({state, commit, dispatch}, payload) {
			// payload must include framework_identifier; add user_id
			payload.user_id = state.user_info.user_id

			return new Promise((resolve, reject)=>{
				U.ajax('get_comments_for_framework', payload, result=>{
					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						console.log('Error retrieving comments')
						reject()
						return
					}
					// console.log(result)

					// splice comment_groups and comments into arrays
					for (let comment_group of result.comment_groups) {
						comment_group = new Comment_Group(comment_group)
						let i = state.comment_groups.findIndex(x=>x.comment_group_id == comment_group.comment_group_id)
						if (i == -1) state.comment_groups.push(comment_group)
						else state.comment_groups.splice(i, 1, comment_group)
					}
					// sort groups by created_at, with later dates (more recently created) on top
					state.comment_groups.sort((a,b)=>U.natural_sort(b.created_at, a.created_at))

					for (let comment of result.comments) {
						comment = new Comment(comment)
						let i = state.comments.findIndex(x=>x.comment_id == comment.comment_id)
						if (i == -1) state.comments.push(comment)
						else state.comments.splice(i, 1, comment)
					}

					// store comments_previous_update_timestamp value for framework_identifier
					state.comments_previous_update_timestamp[payload.framework_identifier] = result.mysql_now

					resolve()
				})
			})
		},

		get_comment_updates_for_framework({state, commit, dispatch}, payload) {
			// payload must include framework_identifier; add user_id and previous_update_timestamp
			payload.user_id = state.user_info.user_id
			payload.previous_update_timestamp = state.comments_previous_update_timestamp[payload.framework_identifier]

			return new Promise((resolve, reject)=>{
				U.ajax('get_comment_updates_for_framework', payload, result=>{
					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						console.log('Error retrieving comment updates')
						reject()
						return
					}
					// console.log(result)

					// splice comment_groups and comments into arrays, removing any that have been archived
					for (let comment_group of result.comment_groups) {
						let i = state.comment_groups.findIndex(x=>x.comment_group_id == comment_group.comment_group_id)
						if (comment_group.archived == 1) {
							if (i > -1) {
								// remove archived comment_group
								state.comment_groups.splice(i, 1)

								// also remove any comments attached to this group
								for (let j = state.comments.length-1; j >= 0; --j) {
									if (state.comments[j].comment_group_id == comment_group.comment_group_id) {
										state.comments.splice(j, 1)
									}
								}
							}

						} else {
							// add/replace new/updated comment group
							comment_group = new Comment_Group(comment_group)
							if (i == -1) state.comment_groups.push(comment_group)
							else state.comment_groups.splice(i, 1, comment_group)
						}
					}

					// return counts for comment updates
					let rr = {
						archive_count: 0,
						update_count: 0,
						new_count: 0,
					}
					for (let comment of result.comments) {
						let i = state.comments.findIndex(x=>x.comment_id == comment.comment_id)
						if (comment.archived == 1) {
							if (i > -1) {
								state.comments.splice(i, 1)
								++rr.archive_count
							}
						} else {
							comment = new Comment(comment)
							if (i == -1) {
								state.comments.push(comment)
								++rr.new_count
							} else {
								state.comments.splice(i, 1, comment)
								++rr.update_count
							}

							// make sure updated comments are marked as not read
							if (state.user_info.comment_reads[comment.comment_id+''] == 1) {
								state.user_info.comment_reads[comment.comment_id+''] = 0
								dispatch('save_user_account_data')
							}
						}
					}

					// store comments_previous_update_timestamp value for framework_identifier
					state.comments_previous_update_timestamp[payload.framework_identifier] = result.mysql_now

					// console.log('comments updated', rr)

					resolve(rr)
				})
			})
		},

		save_comment({state, getters, commit, dispatch}, comment) {
			let payload = {
				user_id: state.user_info.user_id,
				comment_id: comment.comment_id,
				item_identifier: comment.item_identifier,
				framework_identifier: comment.framework_identifier,
				comment_group_id: comment.comment_group_id,
				parent_comment_id: comment.parent_comment_id,
				author_user_id: comment.author_user_id,
				first_name: comment.first_name,
				last_name: comment.last_name,
				body: comment.body,
				suggested_edits: comment.suggested_edits,
				attn_user_id: comment.attn_user_id,
				pinned: comment.pinned,
				resolved: comment.resolved,
			}

			return new Promise((resolve, reject)=>{
				U.loading_start()
				U.ajax('save_comment', payload, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						if (getters.signed_in) {
							vapp.ping()		// call ping to check if the session is expired
							console.log('Error updating comment')
						} else {
							vapp.$alert('Error saving comment')
						}
						reject()
						return
					}

					// if the comment didn't already exist, insert into comments, after updating with returned data
					if (comment.comment_id == 0) {
						comment.comment_id = result.comment_id
						comment.created_at = result.created_at
						// create a new comment class object so we know things will be identical if the user re-edits
						comment = new Comment(comment)
						state.comments.push(comment)

					// else splice the new comment in where the old one was, to make sure all attributes get updated
					} else {
						// create a new comment class object so we know things will be identical if the user re-edits
						comment = new Comment(comment)
						let i = state.comments.findIndex(x=>x.comment_id == comment.comment_id)
						if (i == -1) state.comments.push(comment)
						else state.comments.splice(i, 1, comment)
					}

					resolve(comment)
				})
			})
		},

		save_comment_resolved({state, commit, dispatch}, comment) {
			let payload = {
				user_id: state.user_info.user_id,
				comment_id: comment.comment_id,
				resolved: comment.resolved,
			}

			return new Promise((resolve, reject)=>{
				U.ajax('save_comment_resolved', payload, result=>{
					// note: caller should update resolved value in comment state
					resolve()
				})
			})
		},

		archive_comment({state, commit, dispatch}, comment) {
			let payload = {
				user_id: state.user_info.user_id,
				comment_id: comment.comment_id,
			}
			return new Promise((resolve, reject)=>{
				// if comment_id is 0, it's a newly-created comment that was aborted, so we just have to remove it from state
				if (comment.comment_id == 0) {
					let index = state.comments.findIndex(o=>o == comment)
					state.comments.splice(index, 1)
					resolve()
					return
				}

				U.loading_start()
				U.ajax('archive_comment', payload, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						console.log('Error archiving comment')
						reject()
						return
					}

					// splice the parent and any children out of comments array
					let index
					do {
						index = state.comments.findIndex(o=>o.comment_id == comment.comment_id || o.parent_comment_id == comment.comment_id)
						if (index > -1) state.comments.splice(index, 1)
					} while (index > -1)

					resolve()
				})
			})
		},

		save_user_account_data({state, commit, dispatch}, comment) {
			let payload = {
				user_id: state.user_info.user_id,
				comment_reads: state.user_info.comment_reads_for_save(),
				notification_settings: JSON.stringify(state.user_info.notification_settings),
			}
			return new Promise((resolve, reject)=>{
				U.ajax('save_user_account_data', payload, result=>{
					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						console.log('Error saving user account data')
						reject()
						return
					}

					resolve()
				})
			})
		},

		// debugging fn to clear all comment reads for a user
		// vapp.$store.dispatch('clear_comment_reads')
		clear_comment_reads({state, commit, dispatch}, comment) {
			state.user_info.comment_reads = []
			dispatch('save_user_account_data')
		},

		get_usage_data({state, commit, dispatch}) {
			// if we already have usage_data, return
			if (state.usage_data) return
			U.loading_start()
			return new Promise((resolve, reject)=>{
				U.ajax('get_usage_data', {}, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						vapp.$alert('Couldn’t get usage data')
					} else {
						state.usage_data = {
							files: result,
						}
					}
				})
			})
		},

		///////////////////////////////
		get_resource_sets({state, commit, dispatch}, flag) {
			return new Promise((resolve, reject)=>{
				// if we've already loaded resource_sets, return, unless flag is 'force_reload'
				if (state.resource_sets.length > 0 && flag != 'force_reload') {
					resolve()
					return
				}

				U.loading_start()
				U.ajax('get_resource_sets', {user_id: state.user_info.user_id}, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						vapp.$alert('An error occurred when attempting to retrieve the Resource Set list.')
						reject()
						return
					}

					state.resource_sets = []
					for (let record of result.resource_sets) {
						let json = JSON.parse(record)
						state.resource_sets.push(new Resource_Set(json))
					}

					// also add in CASE frameworks of type `Resource Collection`
					for (let framework_record of state.framework_records) {
						if (U.is_resource_framework(framework_record)) {
							// only add if this person is an editor for the framework
							if (vapp.is_granted('edit_framework', framework_record.lsdoc_identifier)) {
								state.resource_sets.push(new Resource_Set(framework_record))
							}
						}
					}

					resolve()
				})
			})
		},

		get_resource_set_resources({state, commit, dispatch}, resource_set_id) {
			return new Promise((resolve, reject)=>{
				U.loading_start()
				U.ajax('get_resource_set_resources', {user_id: state.user_info.user_id, resource_set_id: resource_set_id}, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						vapp.ping()		// call ping to check if the session is expired
						vapp.$alert('An error occurred when attempting to retrieve the Resource Set.')
						reject()
						return
					}

					// PW: for some reason we were previously json_encoding this data on the server side; not sure why, but I stopped doing this on 11/1/2024
					// let json = JSON.parse(result.resource_set)
					// console.log(json)
					let rs = new Resource_Set(result.resource_set)
					rs.resources_loaded = true

					let i = state.resource_sets.findIndex(x=>x.resource_set_id == resource_set_id)
					if (i == -1) state.resource_sets.push(rs)
					else state.resource_sets.splice(i, 1, rs)

					resolve()
				})
			})
		},

		//////////////////////////////
		reset_service({state, commit, dispatch}) {
			return new Promise((resolve, reject)=>{
				U.ajax('reset', {}, result=>{
					// resolve()
				})
			})
		},

		ping_session({state, commit, dispatch}) {
			vapp.ping()
		},

		////////////////////////////////
		// this.$store.dispatch('sign_out')
		sign_out({state, commit, dispatch}) {
			return new Promise((resolve, reject)=>{
				U.ajax('sign_out', {}, result=>{
					if (result.status != 'ok') {
						alert('Error signing out!')
						reject()
						return
					}

					// clear the session_id from localstorage (if we're using it), since it's no longer valid
					U.local_storage_clear('satchel_session_id')

					vapp.go_to_route('')
					// and reload the window, to be sure everything is clear
					setTimeout(x=>vapp.reload_window(), 10)
				})
			})
		},

		// Done by MZ - align responses to consolidated change_management_utils
		// checkout or checkin framework
		// caller supplies:
		// - framework_identifier
		// - edit_actions [framework_checkout, framework_checkin]
		manage_edit_lock({state, commit, dispatch}, payload) {

			return new Promise((resolve, reject)=>{
				U.ajax('manage_edit_lock', payload, result=>{

					if (result.status == 'ok') {
						resolve(result)

					} else if (result.status == 'lock_conflict') {
						vapp.$alert(result.message)
						reject('checkout rejected due to edit conflict')

					} else if (result.status == 'session_conflict') {
						// this user has lock in another php session
						vapp.$confirm({
							text:'You have this framework checked out in a different edit session, would you like to edit in this window?',
							acceptText: "Edit Here"
						}).then(y => {
							// update edit_lock session_id and extend edit time
							payload['transfer_session'] = true
							dispatch('manage_edit_lock', payload)

							vapp.$inform('Framework checked out to this location.')
							resolve(result)
						}).catch(n => {
							//console.log(n)
							reject('Editor declined transferring framework checkout.')
						}).finally(f=>{})
					} else {
						vapp.$alert('A problem occurred while checking out a framework.')
						reject()
					}

				})
			})
		},

		// test database availability and models
		test_db_model({state, commit, dispatch}) {
			let user = {
				'first_name': 'Mike',
				'last_name': 'Zapp',
				'email': 'zapp@spedcol.org' + U.random_int(10000),
				'system_role': 'admin',
				'login_count': 0,
			}
			let framework_activity = {
				'framework_identifier' : 'd56d1aaa-f540-4a15-95e8-b1954645de23' + U.random_int(10000),
				'user_id': 1121,
				'session_id': 'PHPSESSID2345',
				'action': 'check_out',
			}
			let framework = {
				'framework_identifier': 'd56d1aaa-f540-4a15-95e8-b1954645de23' + U.random_int(10000),
				'framework_type': 'draft',
				'color': 'blue',
				'image_fn': 'folder.png',
			}
			let edit_lock = {
				'framework_identifier' : 'd56d1aaa-f540-4a15-95e8-b1954645de23'+ U.random_int(10000),
				'user_id': 1121,
				'session_id': 'PHPSESSID2345',
				'lock_timestamp' : '*NOW*',
			}
			let payload = {
				user_data: JSON.stringify(user),
				cfa_data: JSON.stringify(framework_activity),
				cf_data: JSON.stringify(framework),
				el_data: JSON.stringify(edit_lock),
			}

			return new Promise((resolve, reject)=>{
				U.loading_start()
				U.ajax('test_db_model', payload, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						vapp.$alert('Error test_db_model.')
						reject()
						return
					}

					vapp.$alert(result.test_result)
					resolve()
				})
			})
		},
		update_editing_enabled({ commit }, { frameworkId, value }) {
			commit('set_editing_enabled', { frameworkId, value })
		},
	}
})
